<script setup lang="ts">
import { onMounted, ref } from 'vue'
import {useFormsStore} from "@/domains/home/services/nir/configurations/stores/forms.ts";

const store = useFormsStore()
const selectedField = ref<string>('')
const loading = ref<boolean>(false)

onMounted(() => {
  store.fetchFields(1, 1000)
  store.fetchFieldLookups(selectedField.value, 1, 1000)
})

function fetch() {
  loading.value = true
  store.fetchFieldLookups(selectedField.value, 1, 1000)
    .then(() => {
      loading.value = false
    })
}

function getStatusColor(status: boolean) {
  return status ? 'text-green-600 bg-green-50' : 'text-gray-600 bg-gray-50'
}

function editField(fieldId: string) {

}
</script>

<template>
  <div class="flex-1 flex flex-col">
    <!-- Action Bar -->
    <div class="flex items-center justify-between mb-4">
      <div class="flex items-center space-x-3">
        <select
          class="px-3 py-2 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-primary focus:border-primary"
          v-model="selectedField" @change="fetch">
          <option value="">All Fields</option>
          <option v-for="field in store.fields" :key="field.id" :value="field.id">
            {{ field.label }}
          </option>
        </select>
      </div>
    </div>

    <!-- Field Lookups Table -->
    <div class="bg-white rounded shadow flex flex-col">
      <div class="overflow-x-auto flex-1">
        <table class="w-full text-xs">
          <thead class="bg-gray-50 sticky top-0">
            <tr>
              <th class="text-left py-3 px-4 font-semibold text-gray-700 border-b border-gray-200">
                Form Field
              </th>
              <th class="text-left py-3 px-4 font-semibold text-gray-700 border-b border-gray-200">
                Label
              </th>
              <th class="text-left py-3 px-4 font-semibold text-gray-700 border-b border-gray-200">
                Value
              </th>
              <th
                class="text-center py-3 px-4 font-semibold text-gray-700 border-b border-gray-200">
                Position
              </th>
              <th
                class="text-center py-3 px-4 font-semibold text-gray-700 border-b border-gray-200">
                Active
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(lookup, idx) in store.fieldLookups" :key="idx" class="hover:bg-gray-50 transition">
              <td class="py-3 px-4 border-b border-gray-200">
                <div class="flex items-center space-x-2 semibold">
                  <p class="font-medium text-gray-900">{{ store.fields?.find(f => f.id == lookup.fieldId)?.label || 'N/A'}}</p>
                </div>
              </td>

              <td class="py-3 px-4 border-b border-gray-200">
                <span class="font-mono text-gray-900 text-xs">{{ lookup.label }}</span>
              </td>

              <td class="py-3 px-4 border-b border-gray-200">
                <span class="font-mono text-gray-900 text-xs">{{ lookup.value }}</span>
              </td>

              <td class="py-3 px-4 text-center border-b border-gray-200">
                <span class="px-2 py-1 bg-gray-100 text-gray-700 rounded text-xs font-medium">
                  {{ lookup.position }}
                </span>
              </td>
              <td class="py-3 px-4 text-center border-b border-gray-200">
                <span
                  :class="getStatusColor(lookup.isActive)"
                  class="px-2 py-1 rounded text-xs font-medium"
                >
                  {{ lookup.isActive ? 'Active' : 'Inactive' }}
                </span>
              </td>
              <td class="py-3 px-4 border-b border-gray-200">
                <div class="flex items-center justify-center space-x-2">
                  <button
                    @click="editField(lookup.fieldId)"
                    class="btn-sm-primary"
                    title="Edit">
                    <i class="fa-solid fa-edit"></i>
                  </button>
                </div>
              </td>
            </tr>
            <!-- Empty State -->
            <tr v-if="!store.fieldLookups || store.fieldLookups.length === 0">
              <td colspan="6" class="py-12 text-center">
                <div class="flex flex-col items-center justify-center text-gray-500">
                  <i class="fa-solid fa-list text-4xl mb-3 text-gray-300"></i>
                  <p class="text-lg font-medium">No field lookups found</p>
                  <p class="text-sm">Select a field or add new lookups to get started</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<style scoped>
table {
  border-collapse: separate;
  border-spacing: 0;
}
</style>
